import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { CountdownModule } from 'ngx-countdown';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ToastContainerModule } from 'ngx-toastr';

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnDragSlideToggleModule } from '@lib/form/drag-slide-toggle';
import { SnFormSliderModule } from '@lib/form/slider';
import { GoogleMapModule } from '@lib/geo/google/map';
import { SnPlayerCommonModule } from '@lib/player/common';
import { TimelineModule } from '@lib/timeline';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { VaultModule } from '@lib/vault';

import { FsBoschPlayerComponent } from './components/bosch-player/bosch-player.component';
import {
  SnVideoPlayerProgressControl,
  SnVideoPlayerAnalysisControl,
  SnVideoPlayerScreenshotControl,
} from './controls';
import { MapStreetViewComponentComponent } from './controls/map-street-view-component/map-street-view-component.component';
import { PtzControlsComponentComponent } from './controls/ptz-controls-component/ptz-controls.component';
import { PtzPresetsComponentComponent } from './controls/ptz-presets-component/ptz-presets.component';
import { VideoPlayerClipControl } from './controls/video-player-clip/video-player-clip.control';
import { SnVideoPlayerComponent } from './video-player.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    // Material
    MatProgressSpinnerModule,
    MatSliderModule,
    MatFormFieldModule,
    MatListModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatCardModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatExpansionModule,
    NgxMaterialTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    MatInputModule,
    ToastContainerModule,
    // Libs
    GoogleMapModule,
    SnPlayerCommonModule,
    SnButtonModule,
    SnIconModule,
    SnCommonModule,
    SnFormModule,
    SnFormSliderModule,
    SnActionsModule,
    CountdownModule,
    TimelineModule,
    VaultModule,
    SnDragSlideToggleModule,
    TranslationModule,
  ],
  exports: [
    SnPlayerCommonModule,
    SnVideoPlayerComponent,
    SnVideoPlayerProgressControl,
    SnVideoPlayerAnalysisControl,
    SnVideoPlayerScreenshotControl,
    PtzPresetsComponentComponent,
    PtzControlsComponentComponent,
    FsBoschPlayerComponent,
  ],
  declarations: [
    SnVideoPlayerComponent,
    SnVideoPlayerProgressControl,
    SnVideoPlayerAnalysisControl,
    SnVideoPlayerScreenshotControl,
    PtzControlsComponentComponent,
    PtzPresetsComponentComponent,
    VideoPlayerClipControl,
    MapStreetViewComponentComponent,
    FsBoschPlayerComponent,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: PtzPresetsComponentComponent,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SnVideoPlayerModule {}
